import type { FaireProductEntity } from "../../entity_types/product";

export const p_9aqt8nwvmc: FaireProductEntity = {
  token: "p_9aqt8nwvmc",
  type: "product",
  name: "Acrylic Black Gingham Cabana Earrings",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/36995dfaba75d275b2862ca2e8a316e7f1f69927017a4fad7c4909e788e43adc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/620ef72b34ebdc8663d1e9176ab54b1207a326e669ab7888248374d82a016cea.jpeg",
  ],
  priceDollars: 3.19,
  description:
    "Gingham Cabana design\n\nGeometric rectangle earrings\n\nAcrylic material\n\nEarring size 1.9CM * 6.3CM",
  tags: [],
  msrpDollars: 6.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:01.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
